import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/company/CompanyTable/CompanyLifecycle/constants";
import useCompanyNumberProps from "components/company/CompanyTable/CompanyNumber/useCompanyNumberProps";

export interface CompanyNumberProps {
  companyNumber: string;
}

const CompanyLifecycle: FunctionComponent<CompanyNumberProps> = ({
  companyNumber,
}) => {
  const { searchWords } = useCompanyNumberProps();

  return (
    <div className="flex flex-col text-14-22 text-neutral-900">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={companyNumber || ""}
      />
    </div>
  );
};

export default CompanyLifecycle;
